import { Directive, ElementRef, HostListener, Input, OnDestroy, OnInit, inject } from '@angular/core';
import { MatCheckbox } from '@angular/material/checkbox';

@Directive({
    selector: 'mat-checkbox[fiCheckboxClickArea]',
    standalone: false,
})
export class FiCheckboxClickAreaDirective implements OnInit, OnDestroy {
    @Input() fiCheckboxClickAreaExclude: string;

    private readonly checkbox = inject(MatCheckbox);
    private readonly el = inject(ElementRef<HTMLElement>);

    private readonly captureListener = (event: MouseEvent): void => {
        if (!this.fiCheckboxClickAreaExclude) {
            return;
        }
        const target = event.target as HTMLElement;
        if (target.closest(this.fiCheckboxClickAreaExclude)) {
            event.preventDefault();
        }
    };

    ngOnInit(): void {
        this.el.nativeElement.addEventListener('click', this.captureListener, true);
    }

    ngOnDestroy(): void {
        this.el.nativeElement.removeEventListener('click', this.captureListener, true);
    }

    @HostListener('click', ['$event'])
    onHostClick(event: MouseEvent): void {
        if (this.checkbox.disabled) {
            return;
        }
        const target = event.target as HTMLElement;
        if (target.closest('.mdc-checkbox') || target.closest('label.mdc-label')) {
            return;
        }
        this.checkbox.toggle();
    }
}
